import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage/LandingPage";
import Chat from "./components/Chat/Chat";


const App = () => (
    <Router>
        <Route path="/" component={LandingPage} exact />
        <Route path="/chat" component={Chat} />
    </Router>
);

export default App;